module.exports = __webpack_public_path__ + "img/d201209-2.572cf353.jpg";